import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

declare var hbspt: any // pega esto arriba del componente

@Component({
  selector: 'bxl-live-streaming',
  templateUrl: 'modal-cta.component.html',
})
export class ModalCtaComponent implements OnInit {
  initialized = false;
  submitted = false;
  @Input() formId: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngAfterContentInit() {
    var nested = this;
    hbspt.forms.create({
      region: "na1",
      portalId: "21144641",
      formId: this.formId,
      //formId: "17e74dcb-2609-478e-848a-ceffdd2c4df2",
      target: "#hubspotForm",
      onFormSubmit: function ($form) {
        nested.submitted = true;
      }
    });
  }

  ngOnInit(): void {
    this.initialized = true;
  }

  public close() {
    this.activeModal.close();
  }
}
